<template>
  <div class="quote-layout">
    <div class="quote-layout__container">
      <keep-alive>
        <router-view v-if="$route.meta.keepCache" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepCache" />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.quote-layout {
  background-color: #f5f5f5;
}
</style>